import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * AuthCallback — handles the OAuth fragment `#session_id=...` from Emergent.
 * Exchanges it for a session cookie via backend, then redirects to /admin/reviews.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/admin/reviews', { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!r.ok) {
          const data = await r.json().catch(() => ({}));
          const msg = data.detail || 'Login failed';
          // Bounce to admin page; it will show login with the error
          navigate(`/admin/reviews?error=${encodeURIComponent(msg)}`, { replace: true });
          return;
        }
        const user = await r.json();
        navigate('/admin/reviews', { replace: true, state: { user } });
      } catch (e) {
        navigate('/admin/reviews?error=network', { replace: true });
      }
    })();
  }, [navigate, location]);

  return (
    <div className="admin-loading" data-testid="auth-callback-loading">
      Signing you in…
    </div>
  );
};

export default AuthCallback;
